import React from "react";
import styles from "../Dashboard.module.scss";
import "./TaskDetailExpandedCard.scss";
import { formatLocalDateTime, formatUTCDateTime } from "utils";

export default function TaskDetailExpandedCard({ t, selectedTask, onBack }) {
  const getStatus = (overallStatus) => {
    const statusMap = {
      1: "In Progress",
      2: "Pending",
      3: "Accepted",
      4: "Started",
      5: "Completed",
      6: "Rejected",
      7: "Cancelled",
    };
    return statusMap[overallStatus] || "";
  };

  const getPriority = (priority) => {
    const priorityMap = {
      1: "HIGH",
      2: "MEDIUM",
      3: "LOW",
    };
    return priorityMap[priority] || "All";
  };

  const getButtonClass = (status) => {
    const statusClasses = {
      Pending: styles.Pending,
      Cancelled: styles.Cancelled,
      Started: styles.Started,
      Accepted: styles.Accepted,
      Rejected: styles.Rejected,
      "In Progress": styles.InProgress,
      Completed: styles.Completed,
    };

    return `${styles.task_management_card_btn} ${statusClasses[status] || ""}`;
  };
  return (
    <div className="d-flex align-items-center p-3">
      <div className="user-image mr-3">
        <span className="link-btn" onClick={() => onBack()}>
          <img
            src={require("assets/images/arrow-back-icon.svg").default}
            alt="arrow"
          />
        </span>
      </div>
      <div className={styles.expandable_container}>
        <div className={styles.data_wrapper}>
          <p
            className={
              getButtonClass(getStatus(selectedTask?.overallStatus)) +
              " " +
              styles.btn_style +
              " " +
              "m-0"
            }
          >
            {getStatus(selectedTask?.overallStatus)}
          </p>

          <div className={styles.priority_with_dot}>
            <span className={styles.priority_dot}></span>
            <p className={styles.priority_text}>
              {getPriority(selectedTask?.priority)}
            </p>
          </div>

          <p className={styles.date}>
            {formatLocalDateTime(selectedTask?.createdAt, "MMM D, YYYY")}
          </p>
        </div>
        <p className={styles.heading}>{selectedTask?.title}</p>
      </div>
    </div>
  );
}
